import { render } from "./IndexView.vue?vue&type=template&id=028596b6"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=028596b6&lang=css"

import exportComponent from "D:\\weixin_repair\\ideamerry_open_repair_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__